import React from "react";
import { Link } from "react-router-dom";
import { Avatar, Badge, Card, Group, Text, Stack } from "@mantine/core";

import entityIcon from "@util/entityIcon";

export default function AdminList({ items = [] }) {
  return (
    <Stack gap="sm">
      {items.map((item) => (
        <Card key={item.id}>
          <Group gap="xs">
            <div>
              <Avatar
                src={
                  item.profile_asset ? item.profile_asset.filename_url : null
                }
                size="lg"
                radius="100%"
              />
            </div>
            <div>
              <Group>
                <Text fw={700} component={Link} to={`/admins/${item.id}`}>
                  {item.first_name} {item.last_name}
                </Text>
                {item.mfa && (
                  <Badge variant="light" color="green">
                    MFA Enabled
                  </Badge>
                )}
              </Group>
              <Group mt={5} gap="xs">
                {entityIcon.email()}
                <Text size="sm">{item.email}</Text>
              </Group>
            </div>
          </Group>
        </Card>
      ))}
    </Stack>
  );
}
